import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import TextLabel from "./TextLabel";
import SmallFormSubmitButton from "./SmallFormSubmitButton";
import styled from "styled-components";
import { t } from "i18next";
import DropdownInputWithLabel from "./DropdownInputWithLabel";
import useAxiosFetchData from "../../hooks/useAxiosFetchData";
import API_Routes from "../../../constants/api-routes";
import { useSelector } from "react-redux";
import {
  apiHostUrl,
  getAreaByFeedbackTypeURL,
  getPriorityforSubArea,
  getSLADetailsURL,
  getSubAreaURL,
  reCalculateSLATimeURL,
} from "../../../constants/constants";
import PickupTarget from "./PickupTarget";
import ResolutionTarget from "./ResolutionTarget";
import ResolutionEscalationMatrixTable from "./ResolutionEscalationMatrixTable";
import useAddModal from "../../hooks/useAddModal";
import AddReceiptModal from "./Modal/AddReceiptModal";
import moment from "moment";
import PickupTargetTime from "./PickupTargetTime";
import { convertDateFormatTo24H, generateAppropriateDate } from "./DateUtils";
import { HorizontalContainer } from "../../../styles/styled-component";
import PluginSnackbar from "./Snackbar";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { CardBody } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ReactModal from "../basic-component/Modal/AddModalCustomer";
import AddReceiptModalBody from "./Modal/AddReceiptModalBody";
import {
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Autocomplete,
  TextField,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { setResponsePendingReducer } from "../../system/redux/reducers/ResponsePendingReducer";
import { v4 as uuidv4 } from "uuid";

const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: calc(5px + 1vw);
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(35vw, 1fr));
  grid-gap: 1rem;
  width: inherit;
  max-width: -webkit-fill-available;
`;
const ViewSLAContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: inherit;
  max-width: -webkit-fill-available;
`;

function SLAContainer({
  deptId,
  fdHandler,
  feedbackId,
  feedbackTypeId,
  conditionList,
  feedbackTypeList,
  status,
  bidderId,
  oldFeedbackList,
  onSuccessFullAddReceipt,
  toggleAddReceiptSnackbarSwitch,
  setSnackbarMessage,
  disableReceiptViewHandler,
  setItemData,
  onModalCloseHandler,
  parentModalOnClose,
  scoopDataForChild,
  modalSwitchHandler,
}) {
  const [modalId, setModalId] = useState(`modal-${uuidv4()}`);
  const { isOpen, val, toggleModal } = useAddModal();
  const [SLADetailsPresent, setSLADetailsPresent] = useState(false); //Button Visibility Controller
  // Constants to be used
  const { csrfToken } = useSelector((state) => state.csrf);
  const [headers, setHeaders] = useState({
    Accept: "*/*",
    "X-Csrf-Token": csrfToken,
    "Content-Type": "application/json",
  });
  const { homeLink } = useSelector((state) => state.role);
  const FeedbackTypeSLA = useMemo(() => [{ id: 100, desc: "Complaint" }]);
  console.log("feedback process condition list", conditionList);
  const [SLAConditionList, setSLAConditionList] = useState(
    conditionList.map((condition) => {
      return {
        id: condition.processConditionId,
        desc: condition.processConditionName,
      };
    })
  );
  const disptach = useDispatch();
  const { assignGroupOnRecalculate: OnSubmitResponsePending } = useSelector(
    (state) => state.ResponsePendingReducer
  );
  const { closeFeedbackOnRecalculate: OnSubmitResponsePendingClose } =
    useSelector((state) => state.ResponsePendingReducer);
  //SLA Details
  const [processConditionId, setProcessConditionId] = useState(null);
  const [processConditionName, setProcessConditionName] = useState(null);
  const [SLAfeedbackTypeId, setSLAfeedbackTypeId] = useState(null);
  const [SLAfeedbackTypeName, setSLAfeedbackTypeName] = useState(null);
  const [masterAreaId, setMasterAreaId] = useState(null);
  const [masterAreaDescription, setMasterAreaDescription] = useState(null);
  const [subAreaId, setSubAreaId] = useState(null);
  const [subAreaDescription, setSubAreaDescription] = useState(null);
  const [priorityId, setPriorityId] = useState(0);
  const [priorityDescription, setPriorityDescription] = useState(null);
  const [SLAPayload, setSLAPayload] = useState(null);
  const [resolutionTarget, setResolutionTarget] = useState([]);
  const [reCalculatePayload, setReCalculatePayload] = useState(null);
  const [addOrCloseReceipt, setAddOrCloseReceipt] = useState(null);
  const [callPriority, setCallPriority] = useState(true);

  //Response payloads
  const [masterArea, setMasterArea] = useState(null);
  const [subArea, setSubArea] = useState(null);
  const [SLADetails, setSLADetails] = useState(null);
  const [priorityResponse, setPriorityResponse] = useState(null);
  const [reCalculatedSLA, setReCalculatedSLA] = useState(null);

  //Dropdown Payloads
  const [masterAreaDropdownPayload, setMasterAreaDropdownPayload] = useState(
    []
  );
  const [subAreaDropdownPayload, setSubAreaDropdownPayload] = useState([]);
  const [feedbackTypeDropdownPayload, setFeedbackTypeDropdownPayload] =
    useState([]);
  const [priorityDropdownPayload, setPriorityDropdownPayload] = useState([]);

  //Visibility Controllers
  const [showMasterArea, setShowMasterArea] = useState(false);
  const [showSubAArea, setShowSubArea] = useState(false);
  const [showPriority, setShowPriority] = useState(false);
  const [rstSubArea, setRstSubArea] = useState(false);
  const [warningSwitch, setWarningSwitch] = useState(false);
  const [snackbarWarningMessage, setSnackbarWarningMessage] = useState("");
  const [masterAreaObj, setMasterAreaObj] = useState(null);
  const [subAreaObj, setSubAreaObj] = useState(null);
  const toggleWarningSwitch = () => {
    setWarningSwitch(!warningSwitch);
    // toggleAddReceiptSnackbarSwitch();
  };
  // const [addReceiptSnackbarSwitch, setAddReceiptSnackbarSwitch] = useState(false);
  // const [closeFeedbackSnackbarSwitch, setCloseFeedbackSnackbarSwitch] = useState(false);
  // const toggleAddReceiptSnackbarSwitch = () => {
  //     setAddReceiptSnackbarSwitch(!addReceiptSnackbarSwitch);
  // }
  // const toggleCloseFeedbackSnackbarSwitch = () => {
  //     setCloseFeedbackSnackbarSwitch(!closeFeedbackSnackbarSwitch);
  // }
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  // const areaLink = `${apiHostUrl}${homeLink}${getAreaByFeedbackTypeURL}/${deptId}/${feedbackTypeId}/${processConditionId}`;
  const { fetchData: getAreaByFeedbackType } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getAreaByFeedbackTypeURL}/${deptId}/${
      feedbackTypeId === 0 ? SLAfeedbackTypeId : feedbackTypeId
    }/${processConditionId}`,
    body: {},
    method: "post",
    headers: headers,
    onLoad: false,
  });
  const [subAreaPayload, setSubAreaPayload] = useState(null);
  const { fetchData: getSubAreaByFeedbackType } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getSubAreaURL}`,
    body: subAreaPayload,
    method: "post",
    headers: headers,
    onLoad: false,
  });
  const { fetchData: getSLADetails } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getSLADetailsURL}`,
    body: SLAPayload,
    method: "post",
    headers: headers,
    onLoad: false,
  });
  const [priorityPayload, setPriorityPayload] = useState(null);
  const { fetchData: getPriorityList } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getPriorityforSubArea}`,
    method: "post",
    body: priorityPayload,
    headers: headers,
    onLoad: false,
  });
  const { fetchData: reCalculateSLA } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${reCalculateSLATimeURL}`,
    body: reCalculatePayload,
    method: "post",
    headers: headers,
    onLoad: false,
  });
  const dispatch = useDispatch();
  //Dropdown Change Handlers
  const onSLAConditionChangeHandler = (event, mode) => {
    console.log("SLA Condition changed to:", event);
    let value;
    if (mode === 0) {
      value = event;
    } else {
      event.target.querySelectorAll("option").forEach((item) => {
        if (item.selected) {
          // console.log(item.value+"--->"+item.text);
          value = { id: item.value, desc: item.text };
        }
      });
    }

    setProcessConditionId(value.id);
    setProcessConditionName(value.desc);
    // setFeedbackTypeDropdownPayload([]);
    setMasterAreaDropdownPayload([]);
    setSubAreaDropdownPayload([]);
    setPriorityDropdownPayload([]);
    setSLADetailsPresent(false);
    setSLADetails(null);
    setSLAPayload(null);
    setReCalculatePayload(null);
    // setShowMasterArea(true);
  };
  const onFeedbackTypeChangeHandler = (event, mode = 0) => {
    console.log("Feedback Type changed to:", event);
    let value;
    if (mode === 0) {
      // console.log(event);
      value = event;
    } else {
      event.target?.querySelectorAll("option").forEach((item) => {
        if (item.selected) {
          // console.log(item.value+"--->"+item.text);
          value = { id: item.value, desc: item.text };
        }
      });
    }

    console.log(value);
    setSLAfeedbackTypeId(value.id);
    setSLAfeedbackTypeName(
      value.desc !== undefined ? value.desc : value.feedbackType
    );
    fdHandler && fdHandler(value.desc);
    // setShowMasterArea(true);
  };
  const onMasterAreaChangeHandler = (value) => {
    if (value !== null && value !== undefined) {
      // console.log(event.target.options,"");
      setSubAreaDropdownPayload([]);
      // let value;
      // event.target.querySelectorAll('option').forEach(item => {
      //     if (item.selected) {
      //         // console.log(item.value+"--->"+item.text);
      //         value = { id: item.value, desc: item.text };
      //     }
      // });
      // event.preventDefault();
      // let value = event.target.value
      // let id = event.target;
      console.log("Master Area changed to:", value);
      setMasterAreaObj(value);
      setMasterAreaId(value.id);
      setMasterAreaDescription(value.desc);
      setSubAreaPayload({ id: value.id, department: { id: deptId } });
      // onClickReset();
      setCallPriority(true);
      reCalculatePayload && setReCalculatePayload(null);
      setSLADetailsPresent(false);
      setSLADetails(null);
      setSubAreaDropdownPayload([]);
      setSLAPayload(null);
      setReCalculatePayload(null);
      setShowSubArea(true);
      setSubAreaObj(null);
    }
  };
  const onSubAreaChangeHandler = (value) => {
    if (value !== null && value !== undefined) {
      console.log("Sub Area changed to:", value);
      // let value;
      // if(mode===1){
      //     event.target.querySelectorAll("option").forEach((item) => {
      //       if (item.selected) {
      //         // console.log(item.value+"--->"+item.text);
      //         value = { id: item.value, desc: item.text };
      //       }
      //     });
      // }
      // else{
      //     value = event;
      // }
      setSubAreaObj(value);
      setSubAreaId(value.id);
      setSubAreaDescription(value.desc);
      if (conditionList[0].processConditionName.includes("Priority")) {
        console.log("Has priority");
        setShowPriority(true);
        setCallPriority(true);
        setPriorityPayload({ id: value.id, department: { id: deptId } });
      } else {
        let data = {
          areaId: masterAreaId,
          departmentId: deptId,
          feedbackId: feedbackId,
          feedbackTypeId: SLAfeedbackTypeId,
          priorityId: priorityId,
          processConditionId: processConditionId,
          processConditionName: conditionList[0].processConditionName,
          subAreaId: value.id,
          // serviceTimingId: 113
        };
        setSLADetailsPresent(false);
        setSLADetails(null);
        setSLAPayload(data);
      }
    }
  };
  const onPriorityChangeHandler = (event) => {
    debugger;
    const value = event.target.value;
    console.log("Priority changed to:", value);
    setPriorityId(value);
    //setPriorityDescription(value.desc);
    let data = {
      areaId: masterAreaId,
      departmentId: deptId,
      feedbackId: feedbackId,
      feedbackTypeId: SLAfeedbackTypeId,
      priorityId: value,
      processConditionId: processConditionId,
      processConditionName: conditionList[0].processConditionName,
      subAreaId: subAreaId,
      // serviceTimingId: 113
    };
    debugger;
    setSLADetailsPresent(false);
    setSLADetails(null);
    setSLAPayload(data);
  };

  //
  const generatePayloadModal = () => {
    console.log("Inside Generate Payload Modal");
    // let { grp_name: assigneeGroupName, ttime } = resolutionTarget[0];
    let data = {
      departmentId: deptId,
      feedbackId: feedbackId,
      feedbackTypeId: SLAfeedbackTypeId,
      assignmentTime: moment().add(120, "hours").format("DD-MM-YYYY h:mm a"),
      warningTimeinMinute:
        SLADetails[2].escalationObj[0].minuteToCalculate.toString(),
      subAreaId: subAreaId,
      status: status,
      departmentSlaAssignmentList: [...resolutionTarget],
      departmentSlaEscalationList:
        // {
        //     escalationStep: "1",
        //     assigneeName: "Ops_Esc",
        //     escalationTime: moment().add(120, 'hours').format("DD-MM-YYYY hh:mm a"),
        //     asigneeGroupId: "525",
        //     asigneeId: "0",
        //     departmentSlaEscalationId: "30694"
        // },
        // SLAPayload[2].escalationObj.forEach((item, index) => ({
        SLADetails[2].escalationObj
          .filter((item, index) => item.escalationStep !== 0)
          .map((item, index) => ({
            escalationStep: item.escalationStep,
            assigneeGroupName: item.assigneeGroupName,
            escalationTime: item.escalationTime,
            asigneeGroupId: item.asigneeGroupId,
            asigneeId: item.asigneeId,
            departmentSlaEscalationId: item.departmentSlaEscalationId,
            minuteToCalculate: item.minuteToCalculate.toString(),
          })),
      taggedFeedbackList:
        // {
        //     feedbackId: "530356",
        //     comment: {
        //         commentGiven: ""
        //     }
        // },
        oldFeedbackList.map((item, index) => ({
          feedbackId: item.id,
          comment: {
            commentGiven: "Some hardcoded texts for now.",
          },
        })),

      pickUpSlaAssignmentObj:
        // {
        //     "asigneeGroupId": "547",
        //     "assignmentTime": "00:30:00",
        //     "departmentSlaId": "16274",
        //     "minuteToCalculate": "30"
        // },
        {
          asigneeGroupId: SLADetails[0].pickupSLAObj.asigneeGroupId,
          assignmentTime: moment()
            .add(120, "hours")
            .format("DD-MM-YYYY h:mm a"),
          departmentSlaId: SLADetails[0].pickupSLAObj.departmentSlaId,
          minuteToCalculate:
            SLADetails[0].pickupSLAObj.minuteToCalculate.toString(),
        },
    };
    // console.log("Modal Payload:", data);
    setReCalculatePayload(data);
    return data;
  };

  const onCloseAddReceiptModal = () => {
    console.log("Inside Close Add Receipt Modal");
  };

  // Button Click Handlers
  const onClickViewSla = () => {
    console.log("View SLA clicked");
    // setSLADetailsPresent(true);
    console.log("SLA Details Present:", SLADetailsPresent);
    console.log(
      "Process Condition Id:",
      processConditionId,
      "Feedback Type Id:",
      SLAfeedbackTypeId,
      "Master Area Id:",
      masterAreaId,
      "Sub Area Id:",
      subAreaId,
      "priority:",
      priorityId
    );
    let data = {
      areaId: masterAreaId,
      departmentId: deptId,
      feedbackId: feedbackId,
      feedbackTypeId: SLAfeedbackTypeId,
      priorityId: priorityId,
      processConditionId: processConditionId,
      processConditionName: conditionList[0].processConditionName,
      subAreaId: subAreaId,
      // serviceTimingId: 113
    };
    // let d = {'feedbackId': "", 'processConditionId': "", 'processConditionName':  "",'feedbackTypeId': "",'serviceTimingId': "",'areaId': "",'subAreaId':  "",'priorityId':  ,'departmentId': };
    setSLAPayload(data);
  };

  const onClickReset = () => {
    console.log("Reset clicked");
    // setProcessConditionId(null);
    // setProcessConditionName(null);
    // setSLAfeedbackTypeId(null);
    // setSLAfeedbackTypeName(null);
    // setMasterAreaId(null);
    // setMasterAreaDescription(null);
    setSubAreaPayload(null);
    setSubAreaId(null);
    setSubAreaDescription(null);
    setShowPriority(false);
    setCallPriority(true);
    // setSubAreaDropdownPayload([]);
    // setShowSubArea(false);
    // setPriorityId(0);
    // setPriorityDescription(null);
    setSLAPayload(null);
    setSLADetailsPresent(false);
    setResolutionTarget([]);
    setReCalculatedSLA(null);
    setSLADetailsPresent(false);
    setRstSubArea(!rstSubArea);
    setMasterAreaObj(null);
    setSubAreaObj(null);
    setSubAreaId(null);
    setMasterAreaId(null);
  };

  const onClickAddReceipt = () => {
    console.log("Add Receipt clicked");
    if (resolutionTarget.length === 0) {
      setSnackbarWarningMessage(t("general.message.select.resolution.group"));
      toggleWarningSwitch();
      return;
    }
    dispatch(setResponsePendingReducer({ assignGroupOnRecalculate: true }));
    let modalPayload = generatePayloadModal();
    setAddOrCloseReceipt("ADD");

    // console.log("Modal Payload:", modalPayload);
    // toggleModal(modalPayload);
  };

  const onClickCloseFeedback = () => {
    console.log("Close Feedback clicked");
    setAddOrCloseReceipt("CLOSE");
    dispatch(setResponsePendingReducer({ closeFeedbackOnRecalculate: true }));
    generatePayloadModal();
  };
  const onClickResolutionTarget = (event) => {
    console.log("Resolution Target clicked", event);
    if (event.length === 0) {
      setResolutionTarget([]);
    }
    event.forEach((item, index) => {
      setResolutionTarget((prev) => [item?.original]);
    });
  };
  const getSLA = () => {
    return [
      {
        pickupSLAObj: {
          createId: 0,
          updateId: 0,
          id: 0,
          departmentSlaId: 16274,
          step: 0,
          minuteToCalculate: "30",
          asigneeId: 0,
          asigneeGroupId: 547,
          asigneeGroupTypeId: 0,
          assignmentTime: "2024-02-19 09:30:40",
          targetTime: 1708315240000,
          asigneeGroupUserId: [],
          assigneeGroupName: "Auc_Resolver_Grp",
          departmentId: 0,
          slaId: 0,
          processConditionRuleId: 8163,
          receiptId: 0,
          targetWarningTime: 1708314760000,
          groupUserList: [
            {
              createId: 0,
              updateId: 0,
              id: 213096,
              firstName: "Tania",
              lastName: "Chakraborti",
              userType: 0,
              buUsertypeId: 0,
              serviceUserId: 0,
              serviceId: 0,
              credentialsNonExpired: false,
              passwordResettable: false,
              errorCode: 0,
            },
            {
              createId: 0,
              updateId: 0,
              id: 214787,
              firstName: "Meghasree ",
              lastName: "Saha",
              userType: 0,
              buUsertypeId: 0,
              serviceUserId: 0,
              serviceId: 0,
              credentialsNonExpired: false,
              passwordResettable: false,
              errorCode: 0,
            },
            {
              createId: 0,
              updateId: 0,
              id: 214864,
              firstName: "amanuddin ",
              lastName: "Ahmed",
              userType: 0,
              buUsertypeId: 0,
              serviceUserId: 0,
              serviceId: 0,
              credentialsNonExpired: false,
              passwordResettable: false,
              errorCode: 0,
            },
          ],
          department: { createId: 0, updateId: 0, id: 318 },
        },
        success: true,
      },
      {
        success: true,
        assignmentObj: [
          {
            createId: 0,
            updateId: 0,
            id: 0,
            departmentSlaId: 16275,
            step: 1,
            minuteToCalculate: "1440",
            asigneeId: 0,
            asigneeGroupId: 547,
            asigneeGroupTypeId: 0,
            assignmentTime: "2024-02-21 17:00:40",
            targetTime: 1708515040000,
            asigneeGroupUserId: [],
            assigneeGroupName: "Auc_Resolver_Grp",
            departmentId: 0,
            slaId: 0,
            processConditionRuleId: 8163,
            receiptId: 0,
            groupUserList: [
              {
                createId: 0,
                updateId: 0,
                id: 213096,
                firstName: "Tania",
                lastName: "Chakraborti",
                userType: 0,
                buUsertypeId: 0,
                serviceUserId: 0,
                serviceId: 0,
                credentialsNonExpired: false,
                passwordResettable: false,
                errorCode: 0,
              },
              {
                createId: 0,
                updateId: 0,
                id: 214787,
                firstName: "Meghasree ",
                lastName: "Saha",
                userType: 0,
                buUsertypeId: 0,
                serviceUserId: 0,
                serviceId: 0,
                credentialsNonExpired: false,
                passwordResettable: false,
                errorCode: 0,
              },
              {
                createId: 0,
                updateId: 0,
                id: 214864,
                firstName: "amanuddin ",
                lastName: "Ahmed",
                userType: 0,
                buUsertypeId: 0,
                serviceUserId: 0,
                serviceId: 0,
                credentialsNonExpired: false,
                passwordResettable: false,
                errorCode: 0,
              },
            ],
            department: { createId: 0, updateId: 0, id: 318 },
          },
        ],
      },
      {
        escalationObj: [
          {
            status: null,
            createId: 0,
            updateId: 0,
            createDate: null,
            updateDate: null,
            errorcode: null,
            errorMsg: null,
            departmentSlaEscalationId: 30652,
            departmentSlaId: 16275,
            escalationStep: 0,
            minuteToCalculate: "1080",
            asigneeId: 0,
            asigneeGroupId: 0,
            asigneeGroupUserId: [],
            assigneeGroupName: null,
            assigneeName: null,
            assigneeEmail: null,
            departmentId: 318,
            slaId: 0,
            processConditionRuleId: 8163,
            escalationTime: "2024-02-21 11:00:40",
            escTime: 1708493440000,
            userList: null,
            receiptId: 0,
          },
          {
            status: null,
            createId: 0,
            updateId: 0,
            createDate: null,
            updateDate: null,
            errorcode: null,
            errorMsg: null,
            departmentSlaEscalationId: 30694,
            departmentSlaId: 16275,
            escalationStep: 1,
            minuteToCalculate: "1440",
            asigneeId: 0,
            asigneeGroupId: 525,
            asigneeGroupUserId: [],
            assigneeGroupName: "Ops_Esc",
            assigneeName: null,
            assigneeEmail: null,
            departmentId: 318,
            slaId: 0,
            processConditionRuleId: 8163,
            escalationTime: "2024-02-21 17:00:40",
            escTime: 1708515040000,
            userList: null,
            receiptId: 0,
          },
          {
            status: null,
            createId: 0,
            updateId: 0,
            createDate: null,
            updateDate: null,
            errorcode: null,
            errorMsg: null,
            departmentSlaEscalationId: 30736,
            departmentSlaId: 16275,
            escalationStep: 2,
            minuteToCalculate: "2880",
            asigneeId: 0,
            asigneeGroupId: 526,
            asigneeGroupUserId: [],
            assigneeGroupName: "BUH_Esc",
            assigneeName: null,
            assigneeEmail: null,
            departmentId: 318,
            slaId: 0,
            processConditionRuleId: 8163,
            escalationTime: "2024-02-26 17:00:40",
            escTime: 1708947040000,
            userList: null,
            receiptId: 0,
          },
          {
            status: null,
            createId: 0,
            updateId: 0,
            createDate: null,
            updateDate: null,
            errorcode: null,
            errorMsg: null,
            departmentSlaEscalationId: 30777,
            departmentSlaId: 16275,
            escalationStep: 3,
            minuteToCalculate: "5760",
            asigneeId: 0,
            asigneeGroupId: 387,
            asigneeGroupUserId: [],
            assigneeGroupName: "Chief_Auctions",
            assigneeName: null,
            assigneeEmail: null,
            departmentId: 318,
            slaId: 0,
            processConditionRuleId: 8163,
            escalationTime: "2024-03-05 17:00:40",
            escTime: 1709638240000,
            userList: null,
            receiptId: 0,
          },
        ],
        success: true,
      },
    ];
  };
  useEffect(() => {
    if (SLAConditionList.length === 1 && processConditionId === null) {
      onSLAConditionChangeHandler(SLAConditionList[0], 0);
    }
    // if (processConditionId !== null) {
    //     getAreaByFeedbackType().then(res => {
    //         setMasterArea(res);
    //         res.forEach(element => {
    //             setMasterAreaDropdownPayload((prev) => ([...prev, { id: element.id, desc: element.description }]));
    //         });
    //     });
    // }

    if (
      feedbackTypeId !== null &&
      !showMasterArea &&
      feedbackTypeDropdownPayload.length < feedbackTypeList.length
    ) {
      // console.log(feedbackTypeDropdownPayload,feedbackTypeList);
      if (feedbackTypeId === 100) {
        setFeedbackTypeDropdownPayload(FeedbackTypeSLA);
        if (FeedbackTypeSLA.length === 1) {
          onFeedbackTypeChangeHandler(FeedbackTypeSLA[0]);
        }
      } else if (feedbackTypeId === 0) {
        if (feedbackTypeList.length === 1) {
          onFeedbackTypeChangeHandler(feedbackTypeList[0]);
        }
        feedbackTypeList.forEach((element) => {
          setFeedbackTypeDropdownPayload((prev) => [
            ...prev,
            { id: element.id, desc: element.feedbackType },
          ]);
          console.log(element);
        });
      } else {
        if (feedbackTypeList.length === 1) {
          onFeedbackTypeChangeHandler(feedbackTypeList[0]);
        }
        feedbackTypeList.forEach((element) => {
          if (element.id !== 100) {
            setFeedbackTypeDropdownPayload((prev) => [
              { id: element.id, desc: element.feedbackType },
            ]);
            onFeedbackTypeChangeHandler(element);
          }
        });
      }
    }

    if (
      ((feedbackTypeId && feedbackTypeId !== 0) ||
        (SLAfeedbackTypeId && SLAfeedbackTypeId !== 0)) &&
      processConditionId !== 0 &&
      processConditionId !== null &&
      !showMasterArea
    ) {
      setSubAreaId(null);
      setSubAreaDescription(null);
      setSLAPayload(null);
      getAreaByFeedbackType().then((res) => {
        setMasterArea(res);
        setShowMasterArea(true);
        res &&
          res.forEach((element) => {
            setMasterAreaDropdownPayload((prev) => [
              ...prev,
              { id: element.id, desc: element.description },
            ]);
          });
      });
    }

    if (
      showSubAArea &&
      subAreaPayload !== null &&
      subAreaDropdownPayload.length === 0
    ) {
      console.log("Before calling subarea", subAreaPayload);
      getSubAreaByFeedbackType().then((res) => {
        setSubArea(res);
        debugger;
        if(res.length===1){
          setSubAreaId(res[0].subAreaId);
          setSubAreaDescription(res[0].description);
          setSubAreaObj({ id: res[0].subAreaId, desc: res[0].description });
          let data = {
            areaId: masterAreaId,
            departmentId: deptId,
            feedbackId: feedbackId,
            feedbackTypeId: SLAfeedbackTypeId,
            priorityId: priorityId,
            processConditionId: processConditionId,
            processConditionName: conditionList[0].processConditionName,
            subAreaId: res[0].subAreaId,
            // serviceTimingId: 113
          };
          setSLADetailsPresent(false);
          setSLADetails(null);
          if (conditionList[0].processConditionName?.includes("Priority")) {
            setShowPriority(true);
            setPriorityPayload({ id: res[0].subAreaId, department: { id: deptId } });
          }
          else{
          setSLAPayload(data);
          }
        }
        res.forEach((element) => {
          // setSubAreaDropdownPayload([]);
          setSubAreaDropdownPayload((prev) => [
            ...prev,
            { id: element.subAreaId, desc: element.description },
          ]);
        });
      });
    }
    if (showPriority && callPriority) {
      setCallPriority(false);
      getPriorityList().then((res) => {
        console.log("Priority Response:", res);
        setPriorityResponse(res);
        if (res.length === 0) {
          setShowPriority(false);
          return;
        }
        setPriorityDropdownPayload(res);
      });
    }

    if (SLAPayload !== null) {
      getSLADetails().then((res) => {
        setSLADetails(res);
        setSLADetailsPresent(true);
        console.log("SLA Details:", res);
      });
      //METAL/2024/328
      // let response = getSLA();
      // setSLADetails(response);
      // setSLADetailsPresent(true);
      // console.log("SLA Details:", response);
    }
    if (reCalculatePayload !== null) {
      reCalculateSLA().then((res) => {
        console.log("Re-Calculated SLA:", res);
        dispatch(
          setResponsePendingReducer({
            assignGroupOnRecalculate: false,
            closeFeedbackOnRecalculate: false,
          })
        );
        setReCalculatedSLA(res);
        debugger;
        let modalPayload = {
          OperationType: addOrCloseReceipt,
          onSuccess: onSuccessFullAddReceipt,
          SLAConditionName: processConditionName,
          FeedbackTypeName: SLAfeedbackTypeName,
          MasterArea: masterAreaDescription,
          SubArea: subAreaDescription,
          Priority: priorityDescription,
          PickupTargetComponent: (
            <PickupTargetTime
              timeString={res.pickUpSlaAssignmentObj.assignmentTime}
            />
          ),
          ResolutionTargetComponent: (
            <ResolutionTarget
              blockSelect
              onClickRow={onClickResolutionTarget}
              resolutionPayload={SLADetails[1].assignmentObj}
            />
          ),
          ResolutionEscalationMatrixComponent: (
            <>
              <br />
              <ResolutionEscalationMatrixTable
                matrixPayload={SLADetails[2].escalationObj}
              />
            </>
          ),

          departmentId: deptId,
          bidderId: bidderId,
          feedbackId: feedbackId,
          feedbackTypeId: SLAfeedbackTypeId,
          assignmentTime: moment()
            .add(120, "hours")
            .format("DD-MM-YYYY h:mm a"),
          warningTime: generateAppropriateDate(res.warningTime),
          warningTimeinMinute: res.warningTimeinMinute,
          subAreaId: subAreaId,
          priorityId: priorityId,
          status: status,
          departmentSlaAssignment: {
            minuteToCalculate:
              res.departmentSlaAssignment.minuteToCalculate.toString(),
            assignmentTime: res.departmentSlaAssignment.assignmentTime,
            targetTime: res.departmentSlaAssignment.targetTime,
          },
          departmentSlaAssignmentList: res.departmentSlaAssignmentList.map(
            (item, index) => {
              return {
                asigneeGroupId: item.asigneeGroupId,
                asigneeId: item.asigneeId,
                assigneeName: item.assigneeGroupName,
                assignmentTime: convertDateFormatTo24H(item.assignmentTime),
                departmentSlaId: item.departmentSlaId,
                step: item.step,
              };
            }
          ),
          departmentSlaEscalationList: SLADetails[2].escalationObj
            .filter((item, index) => item.escalationStep !== 0)
            .map((item, index) => ({
              escalationStep: item.escalationStep,
              assigneeGroupName: item.assigneeGroupName,
              escalationTime: convertDateFormatTo24H(item.escalationTime),
              asigneeGroupId: item.asigneeGroupId,
              asigneeId: item.asigneeId,
              departmentSlaEscalationId: item.departmentSlaEscalationId,
              minuteToCalculate: item.minuteToCalculate
            })),
          taggedFeedbackList: oldFeedbackList.map((item, index) => ({
            feedbackId: item.id,
            comment: {
              commentGiven: "Some hardcoded texts for now.",
            },
          })),

          pickUpSlaAssignmentObj: {
            asigneeGroupId: SLADetails[0].pickupSLAObj.asigneeGroupId,
            assignmentTime: moment(SLADetails[0].pickupSLAObj.assignmentTime)
                      .format("DD-MM-YYYY h:mm a"),
            departmentSlaId: SLADetails[0].pickupSLAObj.departmentSlaId,
            minuteToCalculate:
              SLADetails[0].pickupSLAObj.minuteToCalculate.toString(),
          },
        };
        // toggleModal(modalPayload);
        scoopDataForChild(modalPayload);
        modalSwitchHandler("Child");
        // onModalCloseHandler();
      });
    }
  }, [
    processConditionId,
    feedbackTypeId,
    SLAfeedbackTypeId,
    feedbackTypeList,
    masterAreaId,
    SLAPayload,
    showPriority,
    reCalculatePayload,
  ]);
  return (
    <Col lg="12" style={{ marginTop: "1rem" }}>
      <Row>
        <Col lg="12">
          {SLAConditionList.length > 1 && (
            <Col lg="6">
              <DropdownInputWithLabel
                dropdownItems={SLAConditionList}
                onDropdownChangeHandler={(e) => {
                  onSLAConditionChangeHandler(e, 1);
                }}
                label={t("general.lable.slaCondition")}
              />
            </Col>
          )}

          <Col lg={SLAConditionList > 1 ? "6" : "12"}>
            {
              feedbackTypeDropdownPayload && (
                <DropdownInputWithLabel
                  key={100}
                  label={t("report.page.aging.table.header.feedbacktype")}
                  dropdownItems={feedbackTypeDropdownPayload}
                  onDropdownChangeHandler={onFeedbackTypeChangeHandler}
                />
              )
              //     <>

              //     <TextLabel title={t("report.page.aging.table.header.feedbacktype")} isMandatory></TextLabel>
              //     <Form.Select onChange={onFeedbackTypeChangeHandler} aria-label="Default select example">
              //         <option>Choose</option>
              //         {feedbackTypeDropdownPayload.map((item, index) => {
              //             return (<option key={index} value={item}>
              //                 <a className="dropdown-item">{item.desc}</a>
              //             </option>)
              //         })}
              //     </Form.Select>
              // </>
            }
          </Col>
        </Col>
      </Row>
      <Row>
        <Col lg="6">
          {/* {showMasterArea && */}
          {
            true && (
              <>
                {/* <DropdownInputWithLabel
                     label={t("menu.key.master.area")}
                     dropdownItems={masterAreaDropdownPayload}
                     onDropdownChangeHandler={onMasterAreaChangeHandler}
                     disabled={showMasterArea ? false : true}
                 /> */}
                <TextLabel
                  isMandatory={true}
                  title={t("menu.key.master.area")}
                />
                <Autocomplete
                  disablePortal
                  id="autoCompleteDropdown"
                  value={masterAreaObj}
                  options={masterAreaDropdownPayload}
                  getOptionLabel={(option) => {
                    return option.desc;
                  }}
                  onChange={(event, newvalue) => {
                    // debugger;
                    console.log(event, newvalue);
                    onMasterAreaChangeHandler(newvalue);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                  sx={{ minWidth: "10vw", height: "auto" }}
                  clearIcon={false}
                  filterOptions={(options, state) => {
                    if (state.inputValue.length < 0) {
                      return [];
                    } else {
                      const filteredOptions = options.filter((ele) =>
                        ele?.desc
                          ? ele.desc
                              .toLowerCase()
                              .includes(state.inputValue.toLowerCase())
                          : ele.attributeVal
                              .toLowerCase()
                              .includes(state.inputValue.toLowerCase())
                      );
                      if (filteredOptions.length === 0) {
                        return [
                          {
                            attributeVal: -1,
                            desc: "No data was found",
                            attributeName: "",
                          },
                        ];
                      } else {
                        return filteredOptions;
                      }
                    }
                  }}
                  noOptionsText={t("min.letter.required", {
                    num: 0,
                  })}
                  getOptionDisabled={(option) => option.attributeVal === -1 || option.id===masterAreaId}
                />
              </>
            )
            // <>
            //     {/* <Form.Label className='font-weight-bold'>{t("menu.key.master.area")}</Form.Label> */}
            //     <TextLabel title={t("menu.key.master.area")} isMandatory></TextLabel>
            //     <Form.Select   onChange={onMasterAreaChangeHandler} aria-label="Default select example" disabled={showMasterArea?false:true}>
            //         <option></option>
            //         {masterAreaDropdownPayload.map((item, index) => {
            //             return (<option key={index} value={item.id}> {item.desc}
            //             </option>)
            //         })}
            //     </Form.Select>
            // </>
          }
        </Col>

        <Col lg="6">
          {/* {showSubAArea && */}
          {true && (
            //   <DropdownInputWithLabel
            //     label={t("menu.key.sub.area")}
            //     dropdownItems={subAreaDropdownPayload}
            //     onDropdownChangeHandler={onSubAreaChangeHandler}
            //     disabled={showSubAArea ? false : true}
            //   />
            <>
              <TextLabel isMandatory={true} title={t("menu.key.sub.area")} />
              <Autocomplete
                disablePortal
                id="autoCompleteDropdown"
                value={subAreaObj}
                options={subAreaDropdownPayload}
                getOptionLabel={(option) => {
                  return option.desc;
                }}
                onChange={(event, newvalue) => {
                  // debugger;
                  console.log(event, newvalue);
                  onSubAreaChangeHandler(newvalue);
                }}
                renderInput={(params) => <TextField {...params} />}
                sx={{ minWidth: "10vw", height: "auto" }}
                clearIcon={false}
                filterOptions={(options, state) => {
                  if (state.inputValue.length < 0) {
                    return [];
                  } else {
                    const filteredOptions = options.filter((ele) =>
                      ele?.desc
                        ? ele.desc
                            .toLowerCase()
                            .includes(state.inputValue.toLowerCase())
                        : ele.attributeVal
                            .toLowerCase()
                            .includes(state.inputValue.toLowerCase())
                    );
                    if (filteredOptions.length === 0) {
                      return [
                        {
                          attributeVal: -1,
                          desc: "No data was found",
                          attributeName: "",
                        },
                      ];
                    } else {
                      return filteredOptions;
                    }
                  }
                }}
                noOptionsText={t("min.letter.required", {
                  num: 0,
                })}
                getOptionDisabled={(option) => option.attributeVal === -1 || option.id===subAreaId}
              />
            </>
          )}
        </Col>

        {showPriority && (
          <DropdownInputWithLabel
            label={t("report.page.aging.table.header.priority")}
            dropdownItems={priorityDropdownPayload}
            onDropdownChangeHandler={onPriorityChangeHandler}
          />
        )}

        {/* Timezone is remaining to be looked up from condition name and list to render them */}

        <Col lg="12">
          {SLADetailsPresent && SLADetails && (
            <ViewSLAContainer>
              <PickupTarget
                minuteToCalculate={SLADetails[0].pickupSLAObj.minuteToCalculate.toString()}
              />
              <ResolutionTarget
                selectBlock={false}
                onClickRow={onClickResolutionTarget}
                resolutionPayload={SLADetails[1].assignmentObj}
              />
              <ResolutionEscalationMatrixTable
                matrixPayload={SLADetails[2].escalationObj}
              />
            </ViewSLAContainer>
          )}
        </Col>

        <div className="text-end mt-3">
          {/* {!SLADetailsPresent && <SmallFormSubmitButton onClickHandler={onClickViewSla} buttonText={t('general.lable.viewSLA')} />} */}
          {SLADetailsPresent && (
            <>
              <Button
                variant="outline-dark"
                className="ms-2"
                onClick={onClickReset}
                buttonText={t("general.button.reset.label")}
              >
                {t("general.button.reset.label")}
              </Button>
              <Button
                variant="primary"
                className="ms-2"
                onClick={onClickAddReceipt}
                buttonText={t("menu.key.receipt.add")}
                disabled={
                  OnSubmitResponsePending || OnSubmitResponsePendingClose
                }
              >
                {t("menu.key.receipt.add")}{" "}
                {OnSubmitResponsePending && (
                  <span className="spinner-border spinner-border-sm ml-2"></span>
                )}
              </Button>
              <Button
                variant="primary"
                className="ms-2"
                onClick={onClickCloseFeedback}
                buttonText={t("menu.key.feedback.close")}
                disabled={
                  OnSubmitResponsePendingClose || OnSubmitResponsePending
                }
              >
                {t("menu.key.feedback.close")}{" "}
                {OnSubmitResponsePendingClose && (
                  <span className="spinner-border spinner-border-sm ml-2"></span>
                )}
              </Button>

              {/* <SmallFormSubmitButton onClickHandler={onClickReset} buttonText={t('general.button.reset.label')} /> */}
              {/* <SmallFormSubmitButton onClickHandler={onClickAddReceipt} buttonText={t('menu.key.receipt.add')} /> */}
              {/* <SmallFormSubmitButton onClickHandler={onClickCloseFeedback} buttonText={t('menu.key.feedback.close')} /> */}
            </>
          )}
        </div>
        {/* {isOpen && val && <ReactModal title={"Add Receipt"} show={isOpen} handleClose={toggleModal} modalId={modalId} componentToRender={
                    <AddReceiptModalBody parentModalOnClose={parentModalOnClose} snackBarSwitch={toggleAddReceiptSnackbarSwitch} snackbarMessageHandler={setSnackbarMessage} onModalCloseHandler={() => { document.querySelector(`#${modalId} .btn-close`).click(); toggleModal(); }} setItemData={setItemData} disableRebarMessageHandler={setSnackbarMessage} isShowing={isOpen} hide={toggleModal} val={val} onClose={onCloseAddReceiptModal} disableReceiptViewHandler={disableReceiptViewHandler}/>

                } />} */}
        {/* <AddReceiptModal setItemData={setItemData} disableReceiptViewHandler={disableReceiptViewHandler} snackBarSwitch={toggleAddReceiptSnackbarSwitch} snackbarMessageHandler={setSnackbarMessage} isShowing={isOpen} hide={toggleModal} val={val} onClose={onCloseAddReceiptModal} /> */}
        <PluginSnackbar
          open={warningSwitch}
          message={snackbarWarningMessage}
          onClose={toggleWarningSwitch}
        />
        {/* <PluginSnackbar open={closeFeedbackSnackbarSwitch} message={""} onClose={toggleCloseFeedbackSnackbarSwitch}/> */}
      </Row>
    </Col>
  );
}

export default SLAContainer;
